import React, { useId, useState } from 'react';
import '../styles/OutstandingNote.scss';

// items come from buildOutstanding(); onSelect decides where each one goes.
// collapsible: only the title shows until the user clicks it.
const OutstandingNote = ({ items, daysToVerification, onSelect, title = 'Before verification', collapsible = false }) => {
  const [expanded, setExpanded] = useState(false);
  const bodyId = useId();
  const showBody = !collapsible || expanded;

  return (
    <aside className={`note${collapsible ? ' note--collapsible' : ''}${showBody ? '' : ' is-collapsed'}`}>
      {collapsible ? (
        <h3 className="note-title">
          <button
            type="button"
            className="note-toggle"
            aria-expanded={expanded}
            aria-controls={bodyId}
            onClick={() => setExpanded((v) => !v)}
          >
            <span>{title}</span>
            {items.length > 0 && <span className="note-count">{items.length}</span>}
            <span className="note-chevron" aria-hidden="true" />
          </button>
        </h3>
      ) : (
        <h3 className="note-title">{title}</h3>
      )}
      <div id={bodyId} hidden={!showBody}>
        {items.length === 0 ? (
          <p className="note-empty">Nothing outstanding.</p>
        ) : (
          <ul className="note-list">
            {items.map((item) => (
              <li key={item.id}>
                <button type="button" onClick={() => onSelect(item)}>{item.text}</button>
              </li>
            ))}
          </ul>
        )}
        {daysToVerification != null && (
          <p className="note-due">
            {daysToVerification < 0
              ? 'The verification window is open.'
              : `Verification window opens in ${daysToVerification} days.`}
          </p>
        )}
      </div>
    </aside>
  );
};

export default OutstandingNote;
